import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus } from "lucide-react";
import { CATEGORY_LABEL } from "@/lib/format";
import TransactionsTable from "@/components/TransactionsTable";
import TransactionDialog from "@/components/TransactionDialog";

export default function Transactions() {
  const [items, setItems] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [category, setCategory] = useState("all");
  const [txOpen, setTxOpen] = useState(false);

  const load = async () => {
    const params = {};
    if (startDate) params.start_date = new Date(startDate).toISOString();
    if (endDate) params.end_date = new Date(endDate + "T23:59:59").toISOString();
    if (category !== "all") params.category = category;
    const { data } = await api.get("/transactions", { params });
    setItems(data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [startDate, endDate, category]);
  return (
    <div className="space-y-6" data-testid="transactions-page">
      <div className="flex items-center justify-between">
        <div><div className="text-xs uppercase tracking-widest text-zinc-500">Muhasebe</div><h1 className="text-3xl mt-1">Cari Hareketler</h1></div>
        <Button onClick={()=>setTxOpen(true)} className="bg-zinc-900 hover:bg-zinc-800" data-testid="new-transaction-button"><Plus size={16} className="mr-1"/>Yeni İşlem</Button>
      </div>
      <div className="bg-white p-4 border border-zinc-200 rounded-md flex flex-wrap gap-4 items-end">
        <div><Label>Başlangıç</Label><Input data-testid="filter-start-date" type="date" value={startDate} onChange={(e)=>setStartDate(e.target.value)} /></div>
        <div><Label>Bitiş</Label><Input data-testid="filter-end-date" type="date" value={endDate} onChange={(e)=>setEndDate(e.target.value)} /></div>
        <div>
          <Label>Kategori</Label>
          <Select value={category} onValueChange={setCategory}>
            <SelectTrigger data-testid="filter-category" className="min-w-[180px]"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tümü</SelectItem>
              {Object.keys(CATEGORY_LABEL).map(c=><SelectItem key={c} value={c}>{CATEGORY_LABEL[c]}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <Button variant="ghost" onClick={()=>{setStartDate(""); setEndDate(""); setCategory("all");}}>Filtreleri Temizle</Button>
      </div>
      <TransactionsTable items={items} onChanged={load} />
      <TransactionDialog open={txOpen} onClose={()=>setTxOpen(false)} onSaved={load} title="Yeni İşlem" />
    </div>
  );
}
